module.exports = __webpack_public_path__ + "src/img/stylemarks/feature-small.e7919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/feature-small.jpg
// module id = 114
// module chunks = 0